// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3pRVm","author":"Table_author__1rVZw","authorImage":"Table_authorImage__2nqKT","unreadRow":"Table_unreadRow__XHdE-"};